import type { ComponentType, FC, PropsWithChildren } from 'react';
import React from 'react';

import type { Node } from './../../ricos-schema/legacy/wix/rich_content/v1';

type RicosNodeContextProps = {
  parentNode: Node | null;
  parentIndex: number;
};

type ContextType = {
  parentNode: Node | null;
  parentIndex: number;
};

export const RicosNodeContext = React.createContext<ContextType>(null as unknown as ContextType);

export const RicosNodeContextProvider: FC<PropsWithChildren<RicosNodeContextProps>> = ({
  parentNode,
  parentIndex,
  children,
}) => {
  return (
    <RicosNodeContext.Provider value={{ parentNode, parentIndex }}>
      {children}
    </RicosNodeContext.Provider>
  );
};

export function withRicosNodeContext<Props>(Component: ComponentType<Props>) {
  return function (props: Props) {
    return (
      <RicosNodeContext.Consumer key={Math.random().toString().slice(2, 9)}>
        {({ parentNode, parentIndex }) => (
          <Component {...props} parentNode={parentNode} parentIndex={parentIndex} />
        )}
      </RicosNodeContext.Consumer>
    );
  };
}
